/** Global app-level objects (app, root vm, axios) for code outside components. */

import type {AxiosInstance} from 'axios';
import type {App, ComponentPublicInstance} from 'vue';
import {vuetify} from './plugins/vuetify';

interface IAppState {
   app: App | null;
   vm: ComponentPublicInstance | null;
   http: AxiosInstance | null;
}

const gState: IAppState = {
   app: null,
   vm: null,
   http: null,
};

export function setupAppState(app: App, http: AxiosInstance) {
   gState.app = app;
   gState.http = http;
}

export function setupAppInstance(app: App, vm: ComponentPublicInstance) {
   gState.app = app;
   gState.vm = vm;
}

export function getAppInstance(): App | null {
   return gState.app;
}

export function getAppVm(): ComponentPublicInstance | null {
   return gState.vm;
}

/**
 * Return the global app axios instance.
 */
export function getHttp(): AxiosInstance {
   return gState.http as AxiosInstance;
}

/**
 * True on a small viewport (Vuetify `smAndDown`), for code outside
 * components. Components read `this.$vuetify.display` directly.
 */
export function getIsMobile(): boolean {
   return vuetify.display.smAndDown.value as boolean;
}
